// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin") {
    return true;
  }

  // iTHNK: delivery works deliveries and invoices, and reads companies and contacts
  const readOnly = ["list", "show", "export"].includes(params.action);
  const ithnkResources = ["deliveries", "invoices"];
  if (role === "delivery") {
    if (ithnkResources.includes(params.resource)) return true;
    return ["companies", "contacts"].includes(params.resource) && readOnly;
  }
  // delivery is already refused above for pre_leads and pre_lead_messages; sales and admin pass the default below
  // the do-not-contact list: sales read and add, only admin removes
  if (params.resource === "ithnk_suppressions") {
    return ["list", "show", "create"].includes(params.action);
  }
  // sales (and the legacy "user" role) only read deliveries and invoices
  if (ithnkResources.includes(params.resource)) {
    return readOnly;
  }

  // Non admins can't access the sales resource
  if (params.resource === "sales") {
    return false;
  }

  // Non admins can't access the configuration resource
  if (params.resource === "configuration") {
    return false;
  }

  return true;
};
